import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("tw-animate-pulse tw-rounded-md tw-bg-zinc-100 dark:tw-bg-zinc-800", className)}
      {...props}
    />
  )
}

export { Skeleton }
